import { render, staticRenderFns } from "./VacancyBannerSlider.vue?vue&type=template&id=6feb5ebd&"
import script from "./VacancyBannerSlider.vue?vue&type=script&lang=js&"
export * from "./VacancyBannerSlider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../shared/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports